import { render } from "./Equipments.vue?vue&type=template&id=efdbcb40"
import script from "./Equipments.vue?vue&type=script&lang=js"
export * from "./Equipments.vue?vue&type=script&lang=js"

import "./Equipments.vue?vue&type=style&index=0&id=efdbcb40&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__